import React from 'react';
import StatusSelect, { StatusSelectValueProps } from './StatusSelect';
import { SelectedBooleanStatusType } from './utils';

// TODO: сделать общими с подсказками в иконках
const DANGER_MODE_STATUS = {
  true: 'Опасное явление',
  false: 'Не опасное явление',
  unknown: 'Явление: Неизвестно',
};

export function DangerModeStatusSelect(props: StatusSelectValueProps<SelectedBooleanStatusType>) {
  return (
    <StatusSelect
      {...props}
      statusDescription={DANGER_MODE_STATUS}
      allValuesLabel="Все явления"
    />
  );
}
export default DangerModeStatusSelect;
